// @ts-check

class ProductStickyBar extends HTMLElement {
  constructor() {
    super();
    this.form = this.closest('.product__form__wrapper form');
    this.siteFooter = document.getElementById('SiteFooter');
    if (!this.form) throw new Error('ProductStickyBar must be a child of a form element');
    this.initIntersectionObserver();
  }

  initIntersectionObserver() {
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0,
    };

    this.observer = new IntersectionObserver(this.handleIntersection.bind(this), options);
    this.observer.observe(this.form);

    if (this.siteFooter) {
      this.observer.observe(this.siteFooter);
    }
  }

  /**
   * @param {IntersectionObserverEntry[]} entries
   */
  handleIntersection(entries) {
    entries.forEach((entry) => {
      const atcButton = document.querySelector('.product__submit__item button.product__submit__add');

      if (atcButton && atcButton?.getBoundingClientRect()?.top > window.innerHeight) return;

      this.classList.toggle('is-sticky', !entry.isIntersecting);
      document.body.classList.toggle('pdp-sticky-atc', !entry.isIntersecting);
    });
  }
}

customElements.define('product-sticky-bar', ProductStickyBar);
